<div fxLayout="row" class="p-16 item-badge is-timeline">
    @if (project && project.entryPoint.showBadgeImageTimeline) {
        <div class="pr-5" fxLayout="row" fxLayoutAlign="center flex-start">
            @if (badge.competency.typeCompetency === 0) {
                <img class="img-competency-timeline" src="{{ imagesSvc.getUrlImageCompetency(badge.competency) }}" />
            }
            @if (badge.competency.typeCompetency !== 0) {
                <img class="img-competency-timeline" src="{{ imagesSvc.getUrlImageDefaultMission() }}" />
            }
        </div>
    }

    <div class="person-avatar pr-16" fxLayout="row" fxLayoutAlign="center flex-start">
        @if (project && project.entryPoint.showTimelineGrantor) {
            <img
                class="img-circle"
                [src]="getImagePerson(badge.userDeliver.username)"
                [title]="badge.userDeliver.username"
            />
        }
        @if (project.id == 10) {
            <img
                class="img-circle badge-image"
                [src]="getBadgeImage(this.badge.competency.id)"
                [title]="badge.userDeliver.username"
            />
        }
        @if (project && !project.entryPoint.showTimelineGrantor && badge.userReceive) {
            <img
                class="img-circle"
                [src]="getImagePerson(badge.userReceive.username)"
                [title]="badge.userReceive.username"
            />
        }
        <!--div *ngIf="project && (!project.entryPoint.showTimelineGrantor) && badge.grantees.length>0 && !badge.userReceive" class="img-circle" style="width: 50px; text-align: center;">
    <mat-icon>G</mat-icon>
    </div -->
        @if (project && !project.entryPoint.showTimelineGrantor && badge.grantees.length > 0 && !badge.userReceive) {
            <img [src]="getImageGroup()" class="img-circle" />
        }
    </div>

    <div fxFlex="1 1 0">
        <div fxLayout="row" fxLayoutAlign="space-between flex-start" class="mb-12">
            <p class="m-0">
                @if (project && project.entryPoint.showCompetencyTextTimeline == 1) {
                    {{ "home.badges.from" | translate }}
                    @if (badge?.userDeliver?.externo == 1) {
                        @if (badge.userDeliver && user) {
                            <a matTooltip="Usuario externo" style="cursor: pointer">{{ badge.userDeliver.name }}</a>
                        }
                        <b> (externo)</b>
                    } @else {
                        @if (badge.userDeliver && user) {
                            <a
                                [routerLink]="
                                    badge.userDeliver.id === user.id
                                        ? ['/perfil']
                                        : ['/perfil/@' + badge.userDeliver.username]
                                "
                                style="cursor: pointer"
                                >{{ badge.userDeliver.name }}</a
                            >
                        }
                    }
                    {{ "home.badges.to" | translate }}
                }

                @if (project && project.entryPoint.showCompetencyTextTimeline == 2) {
                    @if (badge?.userDeliver?.externo == 1) {
                        @if (badge.userDeliver && user) {
                            <a style="cursor: pointer" matTooltip="Usuario externo">{{ badge.userDeliver.name }}</a>
                        }
                        <b> (externo)</b>
                    } @else {
                        @if (badge.userDeliver && user) {
                            <a
                                [routerLink]="
                                    badge.userDeliver.id === user.id
                                        ? ['/perfil']
                                        : ['/perfil/@' + badge.userDeliver.username]
                                "
                                style="cursor: pointer"
                                >{{ badge.userDeliver.name }}</a
                            >
                        }
                    }
                    @if (badge.private === 0) {
                        <span>{{ "general.ha_reconocido_a" | translate }}</span>
                    }
                    @if (badge.private === 1) {
                        <span>{{ "general.feedbackdemejora_a" | translate }}</span>
                    }
                }

                @if (badge.userReceive && user) {
                    <a
                        [routerLink]="
                            badge.userReceive.id === user.id ? ['/perfil'] : ['/perfil/@' + badge.userReceive.username]
                        "
                        style="cursor: pointer"
                        >{{ badge.userReceive.name }}</a
                    >
                }

                @if (badge.grantees && badge.grantees.length > 0 && badge.grantees.length <= 10 && !badge.userReceive) {
                    @for (grantee of badge.grantees; track grantee; let i = $index) {
                        @if (i > 0 && i < badge.grantees.length - 1) {
                            <span>, </span>
                        }
                        @if (i == badge.grantees.length - 1) {
                            <span> y </span>
                        }
                        <a
                            [routerLink]="grantee.id === user.id ? ['/perfil'] : ['/perfil/@' + grantee.username]"
                            style="cursor: pointer"
                            >{{ grantee.name }}</a
                        >
                    }
                }

                @if (badge.grantees && badge.grantees.length > 0 && badge.grantees.length > 10 && !badge.userReceive) {
                    <b>{{ badge.grantees.length }} {{ "timeline.users" | translate }}</b>
                }

                @if (project && project.entryPoint.showCompetencyTextTimeline == 1) {
                    {{ "home.badges.for" | translate }} {{ badge.competency.name }}.
                }

                @if (project && project.entryPoint.showCompetencyTextTimeline == 2) {
                    {{ "general.in" | translate }} {{ textTipoCompetencia(badge.competency.typeCompetency) }}.
                }

                @if (project && project.enabled_subject && badge.subject != null && badge.subject !== "") {
                    <p>{{ "general.for" | translate }} {{ badge.subject }}</p>
                }
            </p>
            <p class="badge-date m-0 ml-8" [title]="momentDateFormat(badge.fecha)">
                {{ momentDate(badge.fecha) }}
                @if (project.enabledModPointsBadge) {
                    <br />
                    {{ badge.points }} {{ "general.coins" | translate }}
                }
            </p>
        </div>
        <!-- Feedback mejora -->
        @if (badge.private) {
            <div class="private-badge">
                <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                    <path
                        fill="currentColor"
                        d="M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19M5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5M21.61 2.39C21.61 2.39 16.66 .269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39M14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46M8.88 16.53L7.47 15.12L8.88 16.53M6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L4.83 22H6.24M2 22H3.41L8.18 17.24L6.76 15.83L2 20.59V22M2 19.17L6.09 15.09C5.88 14.79 5.73 14.47 5.64 14.12L2 17.76V19.17Z"
                    />
                </svg>
                <p class="m-0" style="color: darkgreen">
                    <strong>Feedback de mejora</strong>
                </p>
            </div>
        }
        <div class="badge-motivos">
            @for (motivo of badge["competencyIndicator"]; track motivo) {
                <p><b>o</b> {{ motivo.name }}</p>
            }
        </div>
        <div class="p-16 mb-8 badge-comment">
            <p class="m-0">{{ badge.comentario }}</p>
        </div>

        @if (canSeeComments) {
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <p class="text-muted m-0">
                    @if (project && project.enabledBadgeLike) {
                        <span
                            style="cursor: pointer"
                            [matTooltip]="tooltipLikes()"
                            [matTooltipClass]="'tooltip-lines'"
                            [matTooltipShowDelay]="500"
                            >{{ badge.numLikes }} {{ "addOn.comment.likes" | translate }}</span
                        >
                    }
                    ·
                    @if (project && project.enabledBadgeComment && badge) {
                        <a style="cursor: pointer" class="text-muted" (click)="toogleFormComment(badge.id)"
                            >{{ badge.numComments }} {{ "post.comments" | translate }}</a
                        >
                    }
                </p>
                <div fxLayout="row" fxLayoutAlign="center center" class="badge-actions">
                    @if (canEditComments) {
                        @if (project && project.enabledBadgeLike && badge.userDeliver.id !== user.id) {
                            <div>
                                @if (projectId != 472) {
                                    @if (!badge.isLiked) {
                                        <button
                                            mat-stroked-button
                                            color="primary"
                                            class="btn-like"
                                            (click)="toogleLikeBadge()"
                                        >
                                            {{ "addOn.comment.like.btn" | translate }}
                                        </button>
                                    }
                                    @if (badge.isLiked) {
                                        <button
                                            mat-raised-button
                                            color="primary"
                                            class="btn-like active"
                                            (click)="toogleLikeBadge()"
                                        >
                                            {{ "addOn.comment.like.btn" | translate }}
                                        </button>
                                    }
                                } @else {
                                    <button mat-stroked-button class="botonFunespana" (click)="toogleLikeBadge()">
                                        {{ !badge.isLiked ? "Like" : "Deshacer Like" }}
                                    </button>
                                }
                            </div>
                        }
                    }
                    @if (project && project.enabledBadgeComment) {
                        <button
                            mat-icon-button
                            color="primary"
                            class="btn-comments"
                            color="primary"
                            (click)="toogleFormComment(badge.id)"
                        >
                            <mat-icon>chat_bubble</mat-icon>
                        </button>
                    }
                </div>
            </div>

            @if (showFormComent && badge) {
                <fb-comentar [id_badge]="badge.id" [user]="user" [canEdit]="canEditComments"></fb-comentar>
            }
        }
    </div>
</div>
